module.exports = __webpack_public_path__ + "static/media/rectWall.cf36ba43.gif";